export default __webpack_public_path__ + "static/media/10.1dba5e40.jpg";